import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Card } from "react-bootstrap";
import { FiLink } from "react-icons/fi";
// import { BsDot, BsChevronDown, BsPeopleCircle } from "react-icons/bs";
import { IoIosContact } from "react-icons/io";
import { useTranslation } from "react-i18next";
import { Pill } from "evergreen-ui";
import * as userAuthActions from "../../Redux/Actions/user";
import * as localizationActions from "../../Redux/Actions/localization";
import { toastMessage } from "../../utils/toast";
import { getLocaleValue } from "../../utils";
import { clearSession } from "../../utils/initiate";
import JobRequest from "./jobRequest";
import * as notificationActions from "../../Redux/Actions/notifications";
import DeleteModal from "../Ui/DeleteModal/DeleteModal";
import { getToken } from "../../utils/pushNotification";
import { updateToken } from "../../Redux/Actions/notification";


import "./scrollable.css";

const SideNavigation = ({ children, history }) => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState("dashboard");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isArabic, setIsArabic] = useState(
    localStorage.getItem("i18nextLng") === "arabic"
  );
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const pathName = window.location.pathname;
  const [fcmToken, setFcmToken] = useState("");
  const [unReadNotificationCount, setUnReadNotificationCount] = useState(0);
  const [logoutButtonLoading, setLogoutButtonLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth > 1025 ? false : true
  );
  const userData = useSelector(({ User }) => User.data);
 // console.log("user11",userData)
  const NotificationFetchIntervlInMilliSeconds = 60000;

  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 1025); // Set breakpoint at 768px
    }

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    handleUnreadNotificationCount();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      handleUnreadNotificationCount();
    }, NotificationFetchIntervlInMilliSeconds);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [selectedCategory]);

  useEffect(() => {
    if (pathName === "/users" || pathName === "/users/add") {
      setSelectedCategory("users");
    } else if (pathName.includes("master")) {
      setSelectedCategory("masters");
    }

    let selectedValue = window.location.pathname.split("/");
    if (pathName.includes("process-cost")) {
      setSelectedSubCategory(selectedValue[2]);
    } else if (
      pathName.includes("department") ||
      pathName.includes("master-process") ||
      pathName.includes("process")
    ) {
      setSelectedSubCategory(selectedValue[3]);
    }

    if (pathName === "/documents") {
      setSelectedCategory("documents");
    }
  }, [pathName]);
  // handleUserLogout
  const handleUserLogout = () => {
    setShowUserMenu(false);
    setLogoutButtonLoading(false);
    userAuthActions
      .userLogout({ Id: userData.UserId })
      .then((res) => {
        if (res.status === 200) {
          dispatch(userAuthActions.userAuthLogout());
          localStorage.removeItem("jwt");
          localStorage.removeItem("fcmToken");
          history.push("/");
        } else {
          toastMessage("error", "Logout Failed");
        }
      })
      .catch((err) => {
        dispatch(userAuthActions.userAuthLogout());
        localStorage.removeItem("jwt");
        history.push("/");
      });
  };

  useEffect(() => {
    setTimeout(() => {
      let token = localStorage.getItem("fcmToken");
      if (token === "" || token === null) {
        askNotificationPermission();
      }
    }, 2000);
  }, [fcmToken]);

  setTimeout(() => {
    const interval = setInterval(() => {
      if (Notification.permission === "denied") {
        PermissionNotGiven();
      }
      if (Notification.permission === "default") {
        askNotificationPermission();
      }
    }, 30000);

    return () => clearInterval(interval);
  });

  const PermissionNotGiven = () => {
    if (Notification.permission === "denied") {
      // toastMessage("error", "please give permission for Notification");
    }
  };

  const askNotificationPermission = () => {
    let oldToken = localStorage.getItem("fcmToken");
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        getToken(setFcmToken);

        let payload = {
          fcmToken,
          id: userData?.UserId,
        };

        if (
          (oldToken === "" || oldToken === null || oldToken !== fcmToken) &&
          fcmToken !== ""
        ) {
          updateToken(payload).then((res) => {
            localStorage.setItem("fcmToken", fcmToken);
            if (res && res.data) {
              toastMessage("success", "Your notification status updated");
            } else {
              toastMessage("error", "Unable to update the FCM token");
            }
          });
        }
      } else if (permission === "denied") {
        localStorage.removeItem("fcmToken");
      }
    });
  };

  const changeLanguage = (value) => {
    setIsArabic(value);
    i18n.changeLanguage(value ? "arabic" : "english");
  };

  const handleUnreadNotificationCount = () => {
    notificationActions
        .getUnreadNotificationCount()
        .then(({ data }) => {
          if (data) {
            setUnReadNotificationCount(data);
          } else {
            setUnReadNotificationCount(0);
          }
        })
        .catch((err) => {
          if (err.response?.status == 401) {
            clearSession(dispatch, history);
            toastMessage("error", "Session expired. Please login again.");
            if (history && typeof history.push === 'function') {
                history.push('/login');
            }
            window.location.reload();
          }
          console.log(err, err.response, err.message, err.response?.status);
        });
  };

  

  useEffect(() => {
    // add event listener to detect clicks outside of dropdown
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // remove event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      // if click outside dropdown, close it
      setShowUserMenu(false);
    }
  };

  useEffect(() => {}, [window.innerWidth, showMenu]);

  const handleLogoutClose = () => {
    setLogoutButtonLoading(false);
    setShowLogoutModal(false);
  };

  useEffect(() => {
    if (localStorage.getItem("localAr") === null) {
      //To Get English Localizations
      localizationActions
        .localization("EN")
        .then((res) => {
          if (res) {
            localStorage.setItem("localEn", JSON.stringify(res));
            changeLanguage("english");
          } else {
            localStorage.setItem("localEn", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the eng Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
      //-----------------------------------------------------------------------------------------------------
      //To Get Arabic Localizations
      localizationActions
        .localization("AR")
        .then((res) => {
          if (res) {
            localStorage.setItem("localAr", JSON.stringify(res));
          } else {
            localStorage.setItem("localAr", "");
            toastMessage(
              "error",
              (res && res.message) || `Unable to load the ar Localization`
            );
          }
        })
        .catch((err) => {
          err.response?.status === 401 && clearSession(dispatch, history);
        });
    }
  }, []);

  return (
    <div style={{ width: "100vw", overflow: "hidden" }}>
      <div
        className="left-sidenav"
        style={{ display: showMenu && "none", top: 0 }}
      >
        <div
          style={{
            position: "relative",
            zIndex: "1002",
            textAlign: "center",
            top: 0,
            left: 0,
          }}
        >
          <img
            src={"/Assets/aamer_logo.jpg"}
            alt="Logo"
            className="logo logo-lg"
            style={{ width: "130px", height: "auto" }}
          />
        </div>
        <div className="menu-content h-100">
          <ul
            className="metismenu left-sidenav-menu"
            style={{ padding: 0, cursor: "pointer" }}
          >
            {userData.Role === "SUPERADMIN" || userData.Role === "SUBADMIN" || (
              <li
                style={{ marginTop: "1px" }}
                onClick={() => {
                  window.location.pathname.includes("home") &&
                    window.location.reload();
                  history.push("/home");
                  setSelectedCategory("dashboard");
                  handleUnreadNotificationCount();
                }}
              >
                <Card
                  style={{
                    backgroundColor: "#2d207d",
                    height: "55px",
                    borderRadius: 0,
                    marginBottom: 0,
                  }}
                >
                  <img
                    src="/Assets/ion_home.svg"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                    alt=""
                  />
                </Card>
              </li>
            )}{" "}
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/notifications");
                setSelectedCategory("notifications");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <span
                  style={{ position: "absolute", top: "5px", left: "80px" }}
                >
                  <span style={{ marginLeft: "50px" }}>
                    {unReadNotificationCount > 0 && (
                      <Pill color="#b71c1c">{unReadNotificationCount}</Pill>
                    )}
                  </span>
                </span>
                <img
                  src="/Assets/mail.svg"
                  height={"30px"}
                  width={"30px"}
                  style={{ margin: "auto" }}
                  alt=""
                />
              </Card>
            </li>
            {/* 
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/setting");
                setSelectedCategory("settings");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <img
                  src="/Assets/setting.svg"
                  height={"30px"}
                  width={"30px"}
                  style={{ margin: "auto" }}
                  alt=""
                />
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/documentVault");
                setSelectedCategory("documentWallet");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/documentVault" && "text-info")
                  }
                >
                  <span
                    style={{
                      color: "white",
                      fontSize: "15px",
                      margin: "auto",
                    }}
                  >
                    {t("sideNav.documentWallet")}
                  </span>
                </p>
              </Card>
            </li> */}
            {/* <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/jobs");
                setSelectedCategory("jobs");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("home_drawer_jobs")}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/paydueslist");
                setSelectedCategory("paydues");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/paydueslist" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("additional_payments")}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/flyerNotifications");
                setSelectedCategory("flyerNofications");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {getLocaleValue("home_drawer_flyerNotices")}
                  </span>
                </p>
              </Card>
            </li> */}
            {/*  New router  */}
            {userData.Role ===  "AFFILIATEAGENT"?
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/companies");
                setSelectedCategory("companies");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/companies" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {"Companies"}
                  </span>
                </p>
              </Card>
            </li> : null}
            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/jobs");
                setSelectedCategory("jobs");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {"Jobs"}
                  </span>
                </p>
              </Card>
            </li>

            <li
              style={{ marginTop: "1px" }}
              onClick={() => {
                history.push("/reports/consolidated");
                setSelectedCategory("consolidated-reports");
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/reports/consolidated" && "text-info")
                  }
                >
                  <span
                    style={{ margin: "auto", color: "white", fontSize: "15px" }}
                  >
                    {"Consolidated Reports"}
                  </span>
                </p>
              </Card>
            </li>
            <li
              style={{ marginTop: "2px" }}
              onClick={() => {
                setShowLogoutModal(true);
              }}
            >
              <Card
                style={{
                  backgroundColor: "#2d207d",
                  height: "55px",
                  borderRadius: 0,
                  marginBottom: 0,
                }}
              >
                <p
                  className={
                    "c-pointer my-3 d-flex align-items-center " +
                    (pathName === "/jobs" && "text-info")
                  }
                >
                  <img
                    src="/Assets/login.png"
                    height={"30px"}
                    width={"30px"}
                    style={{ margin: "auto" }}
                    alt=""
                  />
                </p>
              </Card>
            </li>
          </ul>
        </div>
      </div>
      <div
        className="page-wrapper"
        style={{ overflowX: "auto", marginLeft: isMobile ? "230px" : "" }}
      >
        <div className="topbar" ref={ref} style={{ position: "inherit" }}>
          <nav className="navbar-custom">
            <ul className="list-unstyled topbar-nav float-end mb-0 d-flex align-items-center">
              <li className="form-switch form-switch-secondary">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="customSwitchSecondary"
                  checked={isArabic}
                  onChange={(e) => changeLanguage(e.target.checked)}
                  style={{ cursor: "pointer", backgroundColor: "#b71c1c" }}
                />
                <label
                  className="form-check-label ps-2 pe-3"
                  htmlFor="customSwitchSecondary"
                  style={{ cursor: "pointer", color: "#b71c1c" }}
                >
                  Arabic
                </label>
              </li>
              <li className="dropdown">
                <p
                  className="nav-link dropdown-toggle waves-effect waves-light nav-user"
                  onClick={() => setShowUserMenu(!showUserMenu)}
                >
                  <span className="me-2 nav-user-name">{userData.Name}</span>
                  <IoIosContact className="font-20" />
                </p>
                <div
                  className={
                    "dropdown-menu dropdown-menu-end " +
                    (showUserMenu ? "show" : "")
                  }
                  style={{ right: "5px" }}
                >
                  {
                    <p
                      className="dropdown-item c-pointer"
                      onClick={() => {
                        history.push("/change-password");
                        setShowUserMenu(false);
                      }}
                    >
                      {t("profile.changePassword")}
                    </p>
                  }
                  <p
                    className="dropdown-item c-pointer"
                    onClick={handleUserLogout}
                  >
                    {t("profile.logout")}
                  </p>
                </div>
              </li>
            </ul>
          </nav>
        </div>
        <div className="page-content" style={{ marginTop: "0px" }}>
          {children}
        </div>
      </div>
      <JobRequest t={t} userID={userData.UserId} />
      {showLogoutModal && (
        <DeleteModal
          handleCancel={handleLogoutClose}
          showModal={showLogoutModal}
          handleOk={handleUserLogout}
          loading={logoutButtonLoading}
          footerOption1={"Logout"}
          footerOption2={"Cancel"}
          type={"logout"}
        ></DeleteModal>
      )}
    </div>
  );
};

export default SideNavigation;
